import axios from 'axios';
import thdcustomer from '@thd-olt-global/thd-customer';
import { executeLoggerService, getLoggerRequest, logEvents } from './Logger.service';
import browserFingerPrint from './BrowserFingerPrint';

const START_TIME = new Date().getTime();
export const baseConsumerAppVersion = '6.19';
export const getCall = (url, hmacEnabled) => {
    const headerObj = getHeaderInfo(hmacEnabled);
    return axios.get(url, {
        headers: headerObj
    });
};
export const postCall = (url, hmacEnabled, data) => {
    const headerObj = getHeaderInfo(hmacEnabled);
    if (window.THD_ACCOUNT_LIB &&
        window.THD_ACCOUNT_LIB.TMX &&
        window.THD_ACCOUNT_LIB.TMX.getTMXsessionId()) {
        headerObj.TMXProfileID = window.THD_ACCOUNT_LIB.TMX.getTMXsessionId();
      }
    return axios.post(url, data, {
        headers: headerObj
    });
};
export const callRenderFormParamsApi = () => {
    const url = '/customer/account/v1/citi/renderFormParameters';
    let startTime = new Date();
    return getCall(url, true).then((resp) => {
        executeLoggerService(getLoggerRequest(url, resp.data, 200, startTime));
        return resp.data;
    }).catch((error) => {
        executeLoggerService(getLoggerRequest(url, 'error calling renderFormParams', error.response.status, startTime));
        return false;
    });
};
export const callSaveCardEndpoint = () => {
    const url = '/customer/account/v1/citi/' + thdcustomer.svocID + '/saveCardToProfile';
    let startTime = new Date();
    return postCall(url, true, '').then((resp) => {
        executeLoggerService(getLoggerRequest(url, resp.data, 200, startTime));
        return resp.data;
    }).catch ((error) => {
        executeLoggerService(getLoggerRequest(url, 'error calling save card', error.response.status, startTime));
        if (error && error.response && error.response.status === 401) {
            redirectToLogin();
            return;
        }
        return error;
    });
};
export const getCitiApplynowUrl = () => {
    const citiDefaultUrl =  'https://citiretailservices.citibankonline.com/CRS/acq/launch/index.action?app=UNSOL&siteId=PLCN_HOMEDEPOT&sc=30005';
    const cmpId = getURLParameters().cmp ? '&cmp=' + getURLParameters().cmp : '';
    return citiDefaultUrl + cmpId;
}
export const getOriginPageUrl = () => {
    let originPageUrl = '';
    try {
      if (getURLParameters().originurl) {
        originPageUrl = decodeURIComponent(getURLParameters().originurl);
        if(originPageUrl.indexOf('homedepot.com') === -1 && originPageUrl.indexOf('homedepotdev.com') === -1) {
          if (window.location.hostname.indexOf(getDomain()) > -1) {
            originPageUrl = 'https://' + window.location.host + originPageUrl;
          }
        }
      }
    } catch(e) {
      console.log('error getting originUrl');
    }
    return originPageUrl;
};;
const getHeaderInfo = (hmacEnabled) => {
    const browserFingerPrintHash = browserFingerPrint();
    const logObj = {
      message: 'hash value generated',
      value: browserFingerPrintHash
    };
    logEvents(logObj);
    let header = {
        Accept: 'application/json',
        'Content-type': 'application/json',
        channelId: isMobile() ? '2' : '1',
        Authorization: thdcustomer.token ? thdcustomer.token : '',
        'cust-acct-client-device-id': browserFingerPrintHash ? browserFingerPrintHash : ''
      };   
    if (hmacEnabled && document.getElementById('hat_env_id')) {
        header['cust-acct-client-id'] = document.getElementById('hat_env_id').value;
        header['cust-acct-client-timestamp'] = document.getElementById('hat_env_ts').value;
        header['cust-acct-client-token'] = document.getElementById('hat_env').value;
        header['cust-acct-client-delay-token-validation'] = getClientDelay();
    }
    return header;
}

const getClientDelay = () => {
    const endTime = new Date().getTime();
    return Math.round((endTime - START_TIME) / 1000);
}

export const getURLParameters = () => {
    const s1 = window.location.search.substring(1, window.location.search.length).split('&');
    let r = {};
    let s2;
    let i;
    for (i = 0; i < s1.length; i += 1) {
      s2 = s1[i].split('=');
      r[decodeURIComponent(s2[0]).toLowerCase()] = decodeURIComponent(s2[1]);
    }
    return r;
};

export const getPathName = (originUrl) => {
  const domain = getDomain();
  let pathName = '';
  if (originUrl.indexOf(domain) > -1){
    const reg = /.+?\:\/\/.+?(\/.+?)(?:#|\?|$)/;
    if (reg.test(originUrl) && reg.exec(originUrl).length > 1) {
      pathName = reg.exec(originUrl)[1];
    }
  }
  return pathName;
};

export const redirectToLogin = (createAccount) => {
    const originUrlParam = getOriginPageUrl() ? '?originUrl=' + encodeURIComponent(getPathName(getOriginPageUrl())): '';
    const logonPath = createAccount ? '/auth/view/createaccount' : '/auth/view/signin';
    const redirectTo = '/account/view/savecardtoprofile' + originUrlParam + '&saveCardToProfileFlow=true';
    let host = 'https://' + window.location.host;
    if (host.indexOf('.homedepot.com') === -1 && host.indexOf('.homedepotdev.com') === -1) {
        host = 'https://www.homedepot.com';
    }
    window.location.href = host + logonPath + (redirectTo ? '?redirect=' + redirectTo : '');
  };

const isTablet = () => {
    let isTabletDevice = false;
    isTabletDevice = (/ipad|xoom|sch-i800|playbook|tablet|kindle/i.test(navigator.userAgent.toLowerCase()));
    return isTabletDevice;
  };
  
  export const isMobile = () => {
    const isMobileDevice = window.matchMedia('(max-width: 640px)').matches ||
      (navigator.userAgent.indexOf('Mobi') > -1 &&
        !isTablet() &&
        window.matchMedia('(orientation:landscape)').matches);
    return isMobileDevice;
  };

  export const readCookie = (cookieName) => {
    const nameEQ = cookieName + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
      }
    }
    return '';
  };
  export const deleteBrowserCookie = (name, domain) => {
    const date = new Date();
    const expires = '; expires=' + date.toString();
    document.cookie = name + '=' + expires + '; path=/; domain=' + domain;
  };
  export const readThdSctpCookie = () => {
    const sctpCookieVal = readCookie('THD_SCTP');
    let sctpJson ='';
    if(sctpCookieVal && sctpCookieVal.split('.')[1]){
        sctpJson = JSON.parse(atob(sctpCookieVal.split('.')[1]));
    }
    return sctpJson;
  }
  export const getDomain = () => {
      if (window.location.host.indexOf('.homedepotdev.com') > -1) {
          return '.homedepotdev.com';
      } else {
          return '.homedepot.com'
      }
  }
  export const isNewerConsumerAppVersion = (baseVersion) => {
    try {
      const baseAppVersion = parseFloat(baseVersion).toFixed(2);
  
      let currentAppVersionStr = '';
      const UAarray = navigator.userAgent.split(' ');
      UAarray.forEach(function (a) {
        if (typeof(a) === 'string' && a.indexOf('THDConsumer') > -1) {
          currentAppVersionStr = a;
        }
      });
      const currentAppVersion = parseFloat(currentAppVersionStr.split('/')[1]).toFixed(2);
      if (currentAppVersion >= baseAppVersion) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      console.log('app check err', e);
      return false;
    }  
  }
  export const getUserAgent = () => {
    try {
      let ua = navigator.userAgent,
        tem,
        M =
          ua.match(
            /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
          ) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return "IE " + (tem[1] || "");
      }
      if (M[1] === "Chrome") {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null)
          return tem
            .slice(1)
            .join(" ")
            .replace("OPR", "Opera");
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
      return M.join(" ");
    } catch (e) {
      console.log("Error getting user browser information");
      return '';
    }
  }




// WEBPACK FOOTER //
// ./src/Components/SaveThdCreditCard/Utils.js